import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageSectionBase } from 'shared/components/ui/page-section-base';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { PageEvents } from 'shared/services/tracking';

import { VisionDetail } from './components/vision-detail';
import * as Styled from './life-area-detail.style';

export const Vision: React.FC = () => {
  const { t } = useTranslation();
  useTrackPageVisitEvent(PageEvents.LifeAreaDetailVision, undefined);

  return (
    <PageSectionBase
      title={t('pages.life-area-detail.sections.vision.label')}
      fullSize
      noPadding
    >
      <Styled.ScrollContainer>
        <VisionDetail />
      </Styled.ScrollContainer>
    </PageSectionBase>
  );
};
